import { SESSION_EXPIRES_TIME } from 'utils/constants'

const sessionExpiresTimeStorage = localStorage.getItem(SESSION_EXPIRES_TIME)
const state = sessionExpiresTimeStorage ? { date: sessionExpiresTimeStorage } : { date: null }

const actions = {
  set ({ commit }, payload) {
    commit('set', payload)
  }
}

const mutations = {
  set ({ commit }, payload) {
    localStorage.setItem(SESSION_EXPIRES_TIME, payload)
    state.date = payload
  }
}

const sessionExpiresTime = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default sessionExpiresTime
